
import { IMRSelectPopoverController } from "./select-popover.controller"

//#region Asset Imports

import './select-popover.scss'
import * as TEMPLATE from './select-popover.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrSelectPopover'

export class IMRSelectPopoverComponent implements ng.IComponentOptions {
    
    controller = [IMRSelectPopoverController]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE

}
